import PropTypes from 'prop-types';

import map from 'lodash/fp/map';

import { legacyTheme } from '@prose-ui/legacy';
import { withStyles } from 'legacyStyles';

import TwoUp from 'Components/LegacyTwoUp';
import { Typography } from 'Components/Typography';

import ConsultationCTA from 'Containers/ConsultationCTA';

import howWorks from 'assets/content/howWorks';

import BlockLayout from './BlockLayout';

const styles = {
  root: {
    maxWidth: legacyTheme.width.veryWide,
    '& p': {
      letterSpacing: '1px',
    },
    [legacyTheme.breakpoints.match('md')]: {
      maxWidth: legacyTheme.width.normal,
    },
  },
  half: {
    maxWidth: legacyTheme.width.half,
    margin: '0 auto',
    [legacyTheme.breakpoints.match('md')]: {
      maxWidth: 'none',
    },
  },
  card: {
    marginBottom: legacyTheme.spacing.s24,
  },
};

const HowWorks = ({ classes, cta, dataFrom }) => {
  return (
    <BlockLayout
      backgroundColor="noir"
      classes={{ content: classes?.root }}
      contentAlignMob="center"
    >
      <TwoUp>
        <div className={classes?.half}>
          <Typography color="white" paragraph variant="h1r">
            {howWorks.title}
          </Typography>
        </div>
        <div className={classes?.half}>
          {map(
            ({ title, content }) => (
              <div key={title} className={classes?.card}>
                <Typography color="white" paragraph variant="h3">
                  {title}
                </Typography>
                <Typography color="white" paragraph variant="p2">
                  {content}
                </Typography>
              </div>
            ),
            howWorks.elements
          )}
          {cta && <ConsultationCTA dataFrom={dataFrom} theme="white" />}
        </div>
      </TwoUp>
    </BlockLayout>
  );
};

HowWorks.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  cta: PropTypes.bool,
  dataFrom: PropTypes.string,
};

HowWorks.defaultProps = {
  dataFrom: 'block-press',
  cta: false,
  classes: null,
};

export default withStyles(HowWorks, styles);
